"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModularHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ModularHeader = function ModularHeader(props) {
  var leftWidgets = props.leftWidgets,
      middleWidgets = props.middleWidgets,
      rightWidgets = props.rightWidgets,
      bottomWidgets = props.bottomWidgets,
      showBackDrop = props.showBackDrop,
      onBackDropClick = props.onBackDropClick,
      leftWidgetClass = props.leftWidgetClass,
      middleWidgetClass = props.middleWidgetClass,
      rightWidgetClass = props.rightWidgetClass,
      toolbarClasses = props.toolbarClasses,
      toolbarGap = props.toolbarGap;
  var classes = (0, _styles.default)();
  var toolbarCustomClasses = toolbarClasses ? toolbarClasses() : null;
  var toolbarDefaultStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: toolbarGap
  };
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    style: toolbarDefaultStyles,
    classes: toolbarCustomClasses
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: leftWidgetClass || ''
  }, leftWidgets.map(function (Widget, k) {
    return _objectSpread(_objectSpread({}, Widget), {}, {
      key: k
    });
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: middleWidgetClass || ''
  }, middleWidgets.map(function (Widget, k) {
    return _objectSpread(_objectSpread({}, Widget), {}, {
      key: k
    });
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: rightWidgetClass || ''
  }, rightWidgets.map(function (Widget, k) {
    return _objectSpread(_objectSpread({}, Widget), {}, {
      key: k
    });
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0
    }
  }, bottomWidgets.map(function (Widget, k) {
    return _objectSpread(_objectSpread({}, Widget), {}, {
      key: k
    });
  })), /*#__PURE__*/_react.default.createElement(_Backdrop.default, {
    className: classes.backdrop,
    open: showBackDrop,
    onClick: onBackDropClick
  }));
};

exports.ModularHeader = ModularHeader;
ModularHeader.propTypes = {
  /** Componente posicionados a esquerda */
  leftWidgets: _propTypes.default.arrayOf(_propTypes.default.node),

  /** Componente posicionados ao centro */
  middleWidgets: _propTypes.default.arrayOf(_propTypes.default.node),

  /** Componente posicionados a direita */
  rightWidgets: _propTypes.default.arrayOf(_propTypes.default.node),

  /** Componente posicionados abaixo */
  bottomWidgets: _propTypes.default.arrayOf(_propTypes.default.node),

  /** Se TRUE mostra o componente BackDrop */
  showBackDrop: _propTypes.default.bool,

  /** Função executada ao clicar no BackDrop */
  onBackDropClick: _propTypes.default.func,

  /** Classe para customização do Left Widget */
  leftWidgetClass: _propTypes.default.string,

  /** Classe para customização do Middle Widget */
  middleWidgetClass: _propTypes.default.string,

  /** Classe para customização do Right Widget */
  rightWidgetClass: _propTypes.default.string,

  /** Classes para customização da barra de ferramentas do Header */
  toolbarClasses: _propTypes.default.func,

  /** Define o espaçamento da barra de ferramentas do Header */
  toolbarGap: _propTypes.default.string
};
ModularHeader.defaultProps = {
  leftWidgets: [],
  middleWidgets: [],
  rightWidgets: [],
  bottomWidgets: [],
  showBackDrop: false,
  onBackDropClick: function onBackDropClick() {
    return null;
  },
  leftWidgetClass: null,
  middleWidgetClass: null,
  rightWidgetClass: null,
  toolbarClasses: null,
  toolbarGap: '1em'
};